import React, { useState } from "react";
import { List, Tag, Typography, Space, Divider, Button, Tooltip } from "antd";

import {
    CheckCircleOutlined,
    CheckOutlined,
    CloseOutlined,
    GlobalOutlined,
    ClockCircleOutlined,
    EditOutlined,
    TagOutlined,
} from "@ant-design/icons";

import { Form, Select, Input } from "formik-antd";
import { isNotValid, translateSymfonyErrorToFormik } from "../../../../core/utils/form";

/* Form & Form Validation */
import * as Yup from "yup";

import ModalForm from "../../../../core/components/form/modalForm";

import PropTypes from "prop-types";

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const propTypes = {
    id: PropTypes.string.isRequired,
    updateTags: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    tags: PropTypes.array.isRequired,
};

const defaultProps = {};

const ProfileTags = (props) => {
    const [modalVisible, setModalVisible] = useState(false);

    const showModal = () => {
        setModalVisible(true);
    };
    const closeModal = () => setModalVisible(false);

    const onSubmit = (values, bag) => {
        const form = { ...values };

        const ret = props.updateTags(props.id, form);

        ret.then((response) => {
            bag.setSubmitting(false);
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                closeModal();
            }
        }).catch((e) => {
            //alert("Se ha producido un error desconocido");
        });

        return;
    };

    const { vendor } = props;
    const initialTags = props.data.tags || [];

    return (
        <>
            <div className="contact-info">
                <h2 className="after-underline">Tags</h2>
                <Button type="link" size="small" con={<EditOutlined />} onClick={showModal}>
                    edit
                </Button>
                <div className="m-t-10 m-b-10">
                    {(props.data.tags || []).map((id) => {
                        if (props.tagsById[id]) {
                            return (
                                <Tooltip key={id} title={props.tagsById[id]?.description}>
                                    <Tag key={id} icon={<TagOutlined />}>
                                        {props.tagsById[id]?.name}
                                    </Tag>
                                </Tooltip>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>

            {modalVisible && (
                <ModalForm
                    title="Edit Tags"
                    enableReinitialize={true}
                    initialValues={{ tags: initialTags }}
                    onSubmit={onSubmit}
                    onCancel={closeModal}
                    visible={modalVisible}
                    render={({ isSubmitting, touched, errors, values, setFieldValue, setFieldTouched }) => (
                        <Form.Item label="Tags" name="tags">
                            <Select
                                name="tags"
                                style={{ width: "100%" }}
                                placeholder="Select multiple"
                                mode="multiple"
                                options={props.tags}
                                filterOption={_filter}
                            />
                        </Form.Item>
                    )}
                />
            )}
        </>
    );
};

ProfileTags.propTypes = propTypes;
ProfileTags.defaultProps = defaultProps;

export default ProfileTags;
